import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import styles from "./Inputs.module.scss";

const DatePickerInput = ({ selectedDate, onDateChange }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateTimePicker
        className={styles.date}
        value={selectedDate ? dayjs(selectedDate) : null}
        onChange={(newDate) => onDateChange(newDate)}
        ampm={false} 
        views={["year", "month", "day", "hours", "minutes"]}
        viewRenderers={{
          hours: renderTimeViewClock,
          minutes: renderTimeViewClock,
          seconds: renderTimeViewClock,
        }}
        format="YYYY-MM-DD HH:mm"
        slotProps={{ textField: { variant: "outlined", fullWidth: true } }}
      />
    </LocalizationProvider>
  );
};

export default DatePickerInput;
